export class Bicycle {
  position: number[];
  heading: number;
  speed: number;
  acceleration: number;
  dt: number = 0.01;

  width = 0.1;
  length = 1.7;
  origin = [this.width / 2, this.length / 2];

  constructor(initialKinematics: number[], dt?: number) {
    if (dt != undefined) this.dt = dt;

    this.acceleration = 0;
    this.speed = initialKinematics[1];
    this.position = [initialKinematics[0], 0];
  }

  reinit(initialKinematics: number[], dt?: number) {
    if (dt != undefined) this.dt = dt;
    this.acceleration = 0;
    this.speed = initialKinematics[1];
    this.position = [initialKinematics[0], 0];
  }

  updatePosition() {
    this.position[0] = this.position[0] + this.speed * this.dt;
    this.position[1] = this.position[1];
  }
}
